<template>
  <div class="wrapper">
    <h1 class="col-sm-8 col-md-6 col-lg-5 col-xl-4" v-html="text"></h1>
    <h1 class="col-sm-8 col-md-6 col-lg-5 col-xl-4 back-text" v-html="backText? backText : text"></h1>
    <h4 class="col-sm-8 col-md-6 col-lg-5 col-xl-4 subtext" v-if="subtext" v-html="subtext"></h4>
    <div class="header-spacer"></div>
  </div>
</template>

<script>
    export default {
        name: "SectionHeader",
        props: ['text', 'subtext', 'backText']
    }
</script>

<style scoped>
  h1 {
    font-weight: bold;
  }

  .wrapper {
    position: relative;
    margin-top: 10vh;
    padding: 0 5px;
    color: #333;
  }

  .header-spacer {
    width: 74px;
    height: 5px;
    margin-bottom: 60px;
    background-color: #000;
  }

  .subtext {
    color: #000;
    font-size: 28px;
    line-height: 1.1em;
    font-weight: 300;
    margin-bottom: 15px;
  }


  .back-text {
    position: absolute;
    left: -47px;
    top: 20px;
    margin-top: -32px;
    color: rgba(0, 0, 0, .03);
    font-size: 10.1em;
    line-height: 40px;
  }
</style>
